import { render, staticRenderFns } from "./BlockPallet.vue?vue&type=template&id=8bd1f248&scoped=true"
import script from "./BlockPallet.vue?vue&type=script&lang=js"
export * from "./BlockPallet.vue?vue&type=script&lang=js"
import style0 from "./BlockPallet.vue?vue&type=style&index=0&id=8bd1f248&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bd1f248",
  null
  
)

export default component.exports